module.exports = __webpack_public_path__ + "static/media/demo.e4a10a7b.jpg";